/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useAuth } from "../providers/AuthProvider";
import EditProfileModal from "src/components/modals/EditProfileModal";
import CustomModal from "src/components/CustomModal";
import { Button } from "src/components/ui/button";
import UpdatePassword from "src/components/modals/UpdatePassword";

const Profile = () => {
	const { user } = useAuth();

	return (
		<div className="tw-max-w-[800px] tw-mx-auto">
			<div className="mx-auto profile_img_wrap tw-w-full">
				<img src={user?.image} className="my-auto profile_img" />
			</div>

			<div className="mx-auto mb-4 profile_content_wrap tw-w-full">
				<h2 className="mb-3">Primary Contact</h2>

				<div className="profile_cont_itm">
					<p>Full Name:</p>
					<p>
						{user.last_name} {user.first_name}
					</p>
				</div>

				<div className="profile_cont_itm">
					<p>Phone:</p>
					<p>{user.phone}</p>
				</div>

				<div className="profile_cont_itm">
					<p>Email:</p>
					<p>{user.email}</p>
				</div>

				<div className="profile_cont_itm">
					<p>Contact Address:</p>
					<p>{user.primary_contact_address}</p>
				</div>

				{/* <div className="profile_cont_itm">
					<p>BVN:</p>
					<p>{user.bvn}</p>
				</div> */}
			</div>

			<div className="mx-auto profile_content_wrap tw-w-full">
				<h2 className="mb-3">Business Contact</h2>

				<div className="profile_cont_itm">
					<p>Business Name:</p>
					<p>{user.business_name}</p>
				</div>

				<div className="mb-4 profile_cont_itm">
					<p>Business Address:</p>
					<p>{user.business_address}</p>
				</div>

				<CustomModal title="Edit Profile" trigger={<Button className="tw-w-full tw-mb-3">Edit Profile</Button>}>
					<EditProfileModal user={user} />
				</CustomModal>
				<CustomModal
					title="Update Password"
					trigger={
						<Button variant="secondary" className="tw-w-full">
							Update Password
						</Button>
					}
				>
					<UpdatePassword />
				</CustomModal>
			</div>
		</div>
	);
};

export default Profile;
